import Game from '../components/game.js';

function Home() {
    return (<Game />)
}

export default Home;